import { useAxios } from 'src/hooks/use-axios';

export function useSuperBundleOfferDelete() {
  return useAxios(
    (axios, baseConfig, url: string) =>
      axios.request({
        ...baseConfig,
        method: 'DELETE',
        url,
      }),
    { neededOnPageLoad: false }
  );
}
